import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";

interface Choice {
  id: string;
  label: string;
}

interface MultipleChoiceStepProps {
  title: string;
  description?: string;
  choices: Choice[];
  selected: string;
  onChange: (value: string) => void;
}

export const MultipleChoiceStep = ({ 
  title, 
  description, 
  choices, 
  selected, 
  onChange 
}: MultipleChoiceStepProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold font-nexa">{title}</h2>
      {description && <p className="text-gray-600">{description}</p>}
      <div className="grid gap-4">
        {choices.map((choice) => (
          <Card
            key={choice.id}
            className={`p-4 cursor-pointer transition-all ${
              selected === choice.id 
                ? "border-secondary bg-primary text-primary-light" 
                : "hover:border-secondary"
            }`}
            onClick={() => onChange(choice.id)}
          >
            <div className="flex items-center justify-between">
              <span className={selected === choice.id ? "text-primary-light" : "text-primary"}>
                {choice.label}
              </span>
              {selected === choice.id && <Check className="h-5 w-5 text-secondary" />}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};